import clsx from "clsx";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { CityCard, TCityCardProps } from "../../components/box/CityCard";
import { TopHeading } from "../../components/heading/TopHeading";
import { BotNav } from "../../components/layout/BotNav";
import { UiTitle } from "../../components/text/UiTitle";
import {
  TUsePopularCitiesRes,
  usePopularCities,
} from "../../components/usePopularCities";

export default function CitiesPage() {
  const { t } = useTranslation();
  const jj = usePopularCities();
  const menus = jj.poplularCitiesRes?.regions;
  useEffect(() => {
    jj.setHoveredTab(0);
  }, []);
  return (
    <>
      <div className="px-4">
        <TopHeading>{t("Cities")}</TopHeading>
        <div className="flex flex-col">
          <UiTitle className="mb-3" text={t("Popular destinations")} />
          <TtGrid
            className="grid-cols-2"
            ls={jj.poplularCitiesRes?.popularDestination}
          />
        </div>

        <TtRegionSwiper {...jj}></TtRegionSwiper>
        <div className="mt-[0.75rem] flex flex-col gap-8">
          {jj.hoveredTab !== undefined &&
            jj.hoveredTab !== null &&
            !!menus &&
            menus[jj.hoveredTab]?.subregion?.map((menu, index: number) => {
              const cities = menu?.country?.flatMap(
                (country) => country.cities,
              );
              return (
                <div className="flex flex-col">
                  <UiTitle className="mb-3" text={menu.areaName} />
                  <TtGrid
                    className="grid-cols-3"
                    ls={(cities ?? []) as TCityCardProps[]}
                  />
                </div>
              );
            })}
        </div>
      </div>
      <BotNav active="CITY" />
    </>
  );
}

export const TtGrid: FC<{
  ls?: TCityCardProps[];
  className?: string;
}> = ({ ls, className }) => {
  return (
    <div className={clsx("grid gap-2", className)}>
      {ls?.map((item, index) => {
        return <CityCard key={index} {...item} />;
      })}
    </div>
  );
};

const TtRegionSwiper = (jj: TUsePopularCitiesRes) => {
  const menus = jj.poplularCitiesRes?.regions;
  return (
    <Swiper className="mt-6" slidesPerView={"auto"}>
      {menus?.map((region, indexMenu) => (
        <SwiperSlide key={region.menuName} className="!w-fit">
          <button
            type="button"
            onClick={() => {
              jj.setHoveredTab(indexMenu);
            }}
            className={clsx("whitespace-nowrap px-4 py-2", {
              "text-[#5E6D77]": jj.hoveredTab !== indexMenu,
              "border-b-[2px] border-[#007AFF] text-[#007AFF]":
                jj.hoveredTab === indexMenu,
            })}
          >
            {region.menuName}
          </button>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
